import { render } from "./GlobalNavigationBar.vue?vue&type=template&id=31f2e492"
import script from "./GlobalNavigationBar.vue?vue&type=script&lang=js"
export * from "./GlobalNavigationBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__